<template>
  <div v-if="aberto" class="modal-overlay" @click.self="fechar">
    <div class="modal-container">
      <div class="modal-header">
        <h2>Auditoria da Sala: {{ nomeSala }}</h2>
        <button class="btn-fechar" @click="fechar">&times;</button>
      </div>

      <div class="modal-body">
        <div v-if="loading" class="modal-loading">
          <span class="spinner"></span>
          <p>Carregando auditoria...</p>
        </div>

        <div v-else-if="loadFailed" class="modal-error">
          <p>Não foi possível carregar os dados.</p>
        </div>

        <div v-else-if="dados.length === 0" class="modal-empty">
          <p>Nenhum registro de auditoria encontrado para esta sala.</p>
        </div>

        <div v-else class="modal-table-wrapper">
          <table class="modal-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Data/Hora</th>
                <th>Ação</th>
                <th>IP</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="audit in dados" :key="audit.id">
                <td>{{ audit.log_id }}</td>
                <td>{{ formatarData(audit.log_created_at) }}</td>
                <td>
                  <span class="acao-badge" :class="getAcaoClass(audit.acao)">
                    {{ audit.log_acao }}
                  </span>
                </td>
                <td>{{ audit.log_ip || 'N/A' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import salasService from '../../service/salas.service';
import { showErrorToast } from '../../service/toast.service';

export default {
  name: 'ModalAuditoriaSala',
  
  props: {
    aberto: {
      type: Boolean,
      required: true
    },
    salaId: {
      type: Number,
      default: null
    },
    nomeSala: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      loading: false,
      loadFailed: false,
      dados: []
    };
  },

  watch: {
    aberto(novoValor) {
      if (novoValor && this.salaId) {
        this.carregarDados();
      } else if (!novoValor) {
        this.limparDados();
      }
    }
  },

  methods: {
    async carregarDados() {
      this.loading = true;
      this.loadFailed = false;
      
      try {
        this.dados = await salasService.getAuditoriaBySala(this.salaId);
      } catch (err) {
        showErrorToast('Não foi possível carregar a auditoria desta sala.');
        this.loadFailed = true;
      } finally {
        this.loading = false;
      }
    },

    fechar() {
      this.$emit('fechar');
    },

    limparDados() {
      this.loading = false;
      this.loadFailed = false;
      this.dados = [];
    },

    formatarData(data) {
      if (!data) return 'N/A';
      const date = new Date(data);
      return date.toLocaleString('pt-BR');
    },

    getAcaoClass(acao) {
      const acaoLower = (acao || '').toLowerCase();
      if (acaoLower.includes('criar') || acaoLower.includes('criar')) return 'acao-criacao';
      if (acaoLower.includes('atualizar') || acaoLower.includes('update')) return 'acao-atualizacao';
      if (acaoLower.includes('deletar') || acaoLower.includes('delete') || acaoLower.includes('remover')) return 'acao-delecao';
      if (acaoLower.includes('desativar')) return 'acao-desativacao';
      return 'acao-outro';
    }
  }
};
</script>

<style scoped src="./ModalAuditoriaSala.css"></style>
